import Reveal from '@/pages/zz-review/components/Reveal';

export default function OverviewSection() {
  return (
    <section id="story" className="w-full py-16 md:py-24 bg-background-100 scroll-mt-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="text-center mb-10">
            <p className="text-xs tracking-[0.2em] uppercase text-foreground-400 mb-3">
              專案故事
            </p>
            <h2
              className="text-2xl md:text-4xl text-foreground-900"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              智慧越強大，生命越需要中軸
            </h2>
          </div>
        </Reveal>

        <Reveal delay={60}>
          <div className="space-y-5 text-base md:text-lg text-foreground-700 leading-relaxed max-w-3xl mx-auto">
            <p>
              當人工智慧、資訊與科技持續加速，我們擁有的工具越來越強；但在工作衝突、金錢壓力、家庭關係與重大決定面前，人未必更清楚自己正在被什麼推著走。
            </p>
            <p>
              我們可能讀過很多成長書、學過很多方法，卻依然在關鍵的一刻被舊慣性代替作完決定。這不只是意志力不足；很多時候，是生命失去了中軸，身體、心智、意向與行動沒有一起工作。
            </p>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="mt-10 rounded-lg border border-primary-200/70 bg-primary-50 px-6 md:px-10 py-8 text-center">
            <p className="text-xs tracking-[0.2em] uppercase text-primary-800 mb-4">
              一句話定位
            </p>
            <p
              className="text-base md:text-xl text-foreground-900 leading-relaxed"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              一本陪伴智人在真實生活中回歸並守住中軸、整合 1D–5D 生命能力，以一年築基走向入世成功，使生命更能成為真實自己的實踐書。
            </p>
          </div>
        </Reveal>

        <Reveal delay={160}>
          <div className="mt-8 text-center max-w-2xl mx-auto">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              《1001旋轉門》想做的事，不是再給你更多道理，而是陪你在真實生活中回歸中軸，把覺察變成選擇，把選擇變成行動，再把行動累積成可回看的生命證據。
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}